import React from 'react'
import { Col, Row } from 'react-bootstrap';
import { Label, Tooltip } from 'fw/components';
import { DocumentUpload } from "areas/shared/controls";
import { Form, CheckBox, Switch, TriStateSwitch } from 'fw/forms';
import { QueueType } from 'areas/shared/consts';

class ReviewUpload extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        const reviewUpload = props.reviewUpload;
        if (reviewUpload && reviewUpload.upload) {
            return {
                form: {
                    uploadKey: reviewUpload.upload.uploadKey,
                    storageToken: reviewUpload.upload.storageToken,
                    fileName: reviewUpload.upload.fileName,
                    notApplicable: reviewUpload.upload.notApplicable,
                    validDocument: reviewUpload.validDocument
                }
            };
        }
        else {
            return {
                form: {
                    uploadKey: "",
                    fileName: null,
                    storageToken: null,
                    notApplicable: false,
                    validDocument: this.props.triState ? null : false
                }
            }
        }
    }

    onChange = (form, callback) => {
        let me = this;
        this.setState(() => {
            return {
                form: {
                    uploadKey: me.state.form.uploadKey,
                    ...form
                }
            }
        }, () => {
            let reviewUpload = {
                upload: {
                    uploadKey: form.uploadKey,
                    storageToken: form.storageToken,
                    fileName: form.fileName,
                    notApplicable: form.notApplicable
                },
                validDocument: form.validDocument
            };
            this.props.onChange(reviewUpload);
            if (callback)
                callback();
        });
    }

    handleUploadChange = (file) => {
        let form = this.state.form;
        form["storageToken"] = file.storageToken;
        form["fileName"] = file.fileName;

        let reviewUpload = {
            upload: {
                uploadKey: form.uploadKey,
                storageToken: form.storageToken,
                fileName: form.fileName,
                notApplicable: form.notApplicable
            },
            validDocument: form.validDocument
        };
        this.props.onChange(reviewUpload);
    };

    notApplicableChange = () => {
        this._upload.blankFile(0);
    }

    switchEnabled = () => {
        var isEnabled = false;
        this.props.availableQueues.forEach(element => {
            isEnabled = isEnabled || (element === this.props.queueTypeCode);
        });
        return !this.props.reviewDisabled && isEnabled;
    }

    render() {
        let me = this;
        const reviewUpload = this.state.form;
        const uploadKey = reviewUpload.uploadKey;

        let controlName = "";
        let notApplicableText = this.props.notApplicableLabel;
        let tooltip = null;
        if (this.props.config && uploadKey) {
            controlName = this.props.config[uploadKey].description;

            // Tooltip
            var tooltipText = this.props.config[uploadKey].tooltip;
            if (tooltipText !== null && tooltipText !== undefined && tooltipText !== "") {
                tooltip = (
                    <Tooltip tip={tooltipText} />
                );
            } else {
                tooltipText = this.props.tip;
                if (tooltipText !== null && tooltipText !== undefined && tooltipText !== "") {
                    tooltip = (
                        <Tooltip tip={tooltipText} />
                    );
                }
            }

            // Set Not applicable label text if it comes from config
            const notApplicableLabelFromConfig = this.props.config[uploadKey].notApplicableLabel;
            if (notApplicableLabelFromConfig !== null && 
                notApplicableLabelFromConfig !== undefined && notApplicableLabelFromConfig !== "")
                notApplicableText = notApplicableLabelFromConfig;
        }

        let ToolbarComponent = this.props.toolbarComponent;
        let switchEnabled = this.switchEnabled();

        return (
            <React.Fragment>
                <Form
                    onChange={me.onChange}
                    values={me.state.form}>
                    <Row>
                        {controlName !== null && controlName !== "" && <Col md={12}>
                            <Label htmlFor={"Upload"} required>
                                <font dangerouslySetInnerHTML={{ __html: controlName }} />
                            </Label>
                            {tooltip !== null && tooltip !== undefined && tooltip}
                        </Col>}
                        <Col md={me.props.triState ? 9 : me.props.formatInline ? 6 : (ToolbarComponent ? 11 : 12)}>
                            <DocumentUpload
                                disabled={me.props.disabled}
                                storageToken={reviewUpload.storageToken}
                                fileName={reviewUpload.fileName}
                                onChange={(file) => me.handleUploadChange(file)}
                                wrapFileNameLength={this.props.wrapFileNameLength}
                                ref={(c) => { me._upload = c; }}
                            />
                        </Col>
                        {ToolbarComponent && <Col md={1}>
                            {ToolbarComponent}
                        </Col>}
                        {me.props.triState && <Col md={2}>
                            {switchEnabled &&
                                <TriStateSwitch
                                    disabled={me.props.disabled}
                                    style={{ paddingTop: '5px' }}
                                    name="validDocument"
                                    labelLeft="Need" labelRight="Valid"
                                    bsStyle="success" />}
                        </Col>
                        }
                        {me.props.formatInline && !me.props.triState && <Col md={5}>
                            {switchEnabled &&
                                <Switch
                                    disabled={me.props.disabled}
                                    style={{ paddingTop: '5px' }}
                                    name="validDocument"
                                    labelLeft="Need Document From Veteran" labelRight="Valid Document"
                                    bsStyle="success" />}
                        </Col>
                        }
                        {me.props.notApplicableAvailable &&
                            <Col md={12}>
                                <CheckBox inline
                                    disabled={me.props.disabled}
                                    onChange={me.notApplicableChange}
                                    name="notApplicable"
                                    label={notApplicableText} />
                            </Col>}
                        {this.props.children &&
                            <Col md={12}>
                                {this.props.children}
                            </Col>}
                    </Row>
                    {!me.props.formatInline && <Row> <Col md={12}>
                        {switchEnabled &&
                            <Switch
                                disabled={me.props.disabled}
                                style={{ paddingTop: '5px' }}
                                name="validDocument"
                                labelLeft="Need Document From Veteran" labelRight="Valid Document"
                                bsStyle="success" />}
                    </Col>
                    </Row>}
                </Form>
            </React.Fragment>
        )
    }
}

ReviewUpload.defaultProps = {
    notApplicableAvailable: true,
    formatInline: true,
    reviewDisabled: false,
    wrapFileNameLength: 50,
    notApplicableLabel: "Not applicable to my Business",
    availableQueues: [
        QueueType.CERTIFICATION_REVIEW.code,
        QueueType.APPLICATION_REVIEW.code,
        QueueType.COMMITTEE_REVIEW.code
    ]
};

export default ReviewUpload


// WEBPACK FOOTER //
// ./src/areas/shared/components/reviewUpload/ReviewUpload.js